import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrangeToFront = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M4.986 4.381a.5.5 0 1 0 .716.697L7.5 3.231v8.723a.5.5 0 1 0 1 0V3.231l1.798 1.847a.5.5 0 1 0 .716-.697l-2.656-2.73a.5.5 0 0 0-.716 0l-2.656 2.73ZM6 6 2.12 7.94a1 1 0 0 0 0 1.79l.95.475-.95.475a1 1 0 0 0 0 1.79l5.21 2.604a1.5 1.5 0 0 0 1.34 0l5.21-2.605a1 1 0 0 0 0-1.789l-.95-.475.95-.476a1 1 0 0 0 0-1.789L10 6v1.118l3.433 1.717L10 10.55v1.118l1.811-.905 1.622.81-5.21 2.606a.5.5 0 0 1-.447 0l-5.21-2.605 1.623-.811L6 11.669v-1.118L2.567 8.835l-.448-.895.448.895L6 7.118V6Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default ArrangeToFront
